import { render, staticRenderFns } from "./policiestable.vue?vue&type=template&id=67f2d408"
import script from "./policiestable.vue?vue&type=script&lang=js"
export * from "./policiestable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports